export enum ActionsType {
  CANCEL_TASKS = "CANCEL_TASKS",
  RESUME_TASKS = "RESUME_TASKS",
  ADD_BRIEFS = "ADD_BRIEFS",
  ADD_NOTES = "ADD_NOTES",
  INVOICE_TASKS = "INVOICE_TASKS",
  EDIT_TASKS = "EDIT_TASKS",
  DELIVER_TASKS = "DELIVER_TASKS",
  AUTO_DELIVER = "AUTO_DELIVER",
}
